var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPointEvent)?_c('v-row',[_c('v-col',{attrs:{"cols":"7"}},[_c('div',{staticClass:"text-body-1"},[_vm._v(_vm._s(_vm.label)+": "+_vm._s(_vm.value))])]),_c('v-col',{attrs:{"cols":"5"}},[_c('div',{staticClass:"text-body-1"},[_vm._v(_vm._s(_vm.timestamp))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }